"use client";

import { useState, useEffect, useCallback } from "react";

interface TypeWriterProps {
    words: string[];
    typingSpeed?: number;
    deletingSpeed?: number;
    pauseTime?: number;
    className?: string;
}

export function TypeWriter({
    words,
    typingSpeed = 80,
    deletingSpeed = 50,
    pauseTime = 2000,
    className = "",
}: TypeWriterProps) {
    const [text, setText] = useState("");
    const [wordIndex, setWordIndex] = useState(0);
    const [isDeleting, setIsDeleting] = useState(false);

    const tick = useCallback(() => {
        const currentWord = words[wordIndex];
        if (!isDeleting) {
            setText(currentWord.slice(0, text.length + 1));
            if (text.length + 1 === currentWord.length) {
                setTimeout(() => setIsDeleting(true), pauseTime);
                return;
            }
        } else {
            setText(currentWord.slice(0, text.length - 1));
            if (text.length - 1 === 0) {
                setIsDeleting(false);
                setWordIndex((prev) => (prev + 1) % words.length);
                return;
            }
        }
    }, [text, wordIndex, isDeleting, words, pauseTime]);

    useEffect(() => {
        const speed = isDeleting ? deletingSpeed : typingSpeed;
        const timer = setTimeout(tick, speed);
        return () => clearTimeout(timer);
    }, [tick, isDeleting, deletingSpeed, typingSpeed]);

    return (
        <span className={className}>
            {text}
            <span className="inline-block w-[3px] h-[1em] ml-1 bg-dev-cyan animate-pulse align-middle" />
        </span>
    );
}
